// extracted by mini-css-extract-plugin
export var actionButton = "_dc-0";
export var fileInput = "_dc-2";
export var paperclip = "_dc-1";